'use client'

import { Button } from '@ui/web/components'
import { StickyBanner as StickyBannerComponent, typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

import { useHasStickyBanner } from '~/context'

interface StickyBannerProps {
  className?: string
}

export function StickyBanner({ className }: StickyBannerProps) {
  const { hasStickyBanner, stickyBanner } = useHasStickyBanner()

  if (!hasStickyBanner || !stickyBanner) return null

  return (
    <StickyBannerComponent className={cn('srd:bg-purple-100 srd:text-neutral-white', className)}>
      <p
        className={cn(
          typographyVariants({ variant: 'body-md' }),
          'srd:mx-0 srd:max-w-[90%] srd:overflow-x-auto srd:drop-shadow-md',
        )}
      >
        {stickyBanner.text}{' '}
        <Button baseButton size='xs' variant='outline' className='srd:text-current' asChild>
          <a href={stickyBanner.cta.link}>{stickyBanner.cta.text}</a>
        </Button>
      </p>
    </StickyBannerComponent>
  )
}
